
/**
 * ノベルティ自動付与
 * ファイル名: original-novelty-system.js
 * 配置場所: assets/original-novelty-system.js
 * 作成者: yama
 * 指定タグ商品 + 金額条件でノベルティ商品を自動追加/削除
 */


// =========================
//  定数
// =========================
const NOVELTY_CONFIG = {
  DELAYS: {
    CART_MONITOR: 500,
    UI_UPDATE: 800,
    LABEL_AUTO_REMOVE: 3000,
    SYSTEM_INIT: 2000,
    BUTTON_CLICK: 1500
  },
  SELECTORS: {
    REMOVE_BUTTONS: 'cart-remove-button, .cart-remove, [data-cart-remove]',
    QUANTITY_BUTTONS: 'button.quantity__button, input.quantity__input',
    PRODUCT_LINKS: '.cart-item__name a, a[href*="/products/"]'
  }
};

// =========================
//  グローバル
// =========================
let isProcessing = false;
let cartProductTags = {};
window.noveltyReady = true;

// =========================
//  判定中UI
// =========================
const PREP = {
  ROOT_SEL: '.cart-drawer, .cart, [data-cart-section]'
};

// カートルート要素はDOM置換（innerHTML差し替え）後も接続が維持されるため、
// 毎回の document.querySelector を避けてキャッシュ参照を再利用する
let cachedCartRoot = null;
function getCartRoot() {
  if (cachedCartRoot && cachedCartRoot.isConnected) return cachedCartRoot;
  cachedCartRoot = document.querySelector(PREP.ROOT_SEL) || document.body;
  return cachedCartRoot;
}

function injectPreparingStylesOnce() {
  if (document.getElementById('novelty-preparing-style')) return;
  const style = document.createElement('style');
  style.id = 'novelty-preparing-style';
  style.textContent = `
  .novelty-preparing button.quantity__button,
  .novelty-preparing input.quantity__input,
  .novelty-preparing cart-remove-button,
  .novelty-preparing .cart-remove,
  .novelty-preparing [data-cart-remove],
  .novelty-preparing .cart-item__name a,
  .novelty-preparing a[href*="/products/"] {
    opacity: .5;
    cursor: not-allowed !important;
  }
  .novelty-preparing-overlay {
    position: absolute;
    inset: 0;
    display: grid;
    place-items: center;
    gap: 8px;
    pointer-events: none;
    background: rgba(250,250,250,0.55);
    z-index: 9999;
  }
  .np-spinner {
    width: 28px; height: 28px;
    border: 3px solid rgba(0,0,0,0.12);
    border-top-color: rgba(0,0,0,0.45);
    border-radius: 50%;
    animation: np-spin 0.9s linear infinite;
  }
  @keyframes np-spin { to { transform: rotate(360deg); } }
  .np-text { font-size: 12px; color: #555; }
  .novelty-preparing-toast {
    position: fixed; left: 50%; top: 50%;
    transform: translate(-50%, -50%);
    background: rgba(60,60,60,0.92);
    color: #fff;
    padding: 10px 16px; border-radius: 8px;
    z-index: 10000; font-size: 13px;
  }`;
  document.head.appendChild(style);
}

function ensurePreparingOverlay(root) {
  const old = document.querySelector('.novelty-preparing-overlay');
  if (old) old.remove();

  const wrap = document.createElement('div');
  wrap.className = 'novelty-preparing-overlay';
  wrap.setAttribute('role', 'status');
  Object.assign(wrap.style, {
    position: 'fixed',
    left: '0', top: '0', right: '0', bottom: '0',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    background: 'rgba(250,250,250,0.55)',
    zIndex: '2147483647'
  });

  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  svg.setAttribute('width', '34');
  svg.setAttribute('height', '34');
  svg.setAttribute('viewBox', '0 0 50 50');
  svg.setAttribute('aria-hidden', 'true');

  const circleBg = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circleBg.setAttribute('cx', '25');
  circleBg.setAttribute('cy', '25');
  circleBg.setAttribute('r', '20');
  circleBg.setAttribute('stroke', 'rgba(0,0,0,0.15)');
  circleBg.setAttribute('stroke-width', '4');
  circleBg.setAttribute('fill', 'none');

  const arc = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  arc.setAttribute('d', 'M25 5 A20 20 0 0 1 42.32 14.64');
  arc.setAttribute('stroke', 'rgba(0,0,0,0.55)');
  arc.setAttribute('stroke-width', '4');
  arc.setAttribute('fill', 'none');
  arc.setAttribute('stroke-linecap', 'round');

  const anim = document.createElementNS('http://www.w3.org/2000/svg', 'animateTransform');
  anim.setAttribute('attributeName', 'transform');
  anim.setAttribute('attributeType', 'XML');
  anim.setAttribute('type', 'rotate');
  anim.setAttribute('from', '0 25 25');
  anim.setAttribute('to', '360 25 25');
  anim.setAttribute('dur', '0.9s');
  anim.setAttribute('repeatCount', 'indefinite');
  arc.appendChild(anim);

  svg.appendChild(circleBg);
  svg.appendChild(arc);

  const text = document.createElement('div');
  text.className = 'np-text';
  text.textContent = 'カート内判定中…';
  Object.assign(text.style, { fontSize: '13px', color: '#444' });

  wrap.appendChild(svg);
  wrap.appendChild(text);
  document.body.appendChild(wrap);
}

function showPreparingToast() {
  if (document.querySelector('.novelty-preparing-toast')) return;
  const el = document.createElement('div');
  el.className = 'novelty-preparing-toast';
  el.textContent = '判定中のため操作できません…';
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 1200);
}

function attachPreparingGuards(root) {
  if (root.__np_guard_attached) return;
  root.__np_guard_attached = true;

  root.addEventListener('click', (ev) => {
    if (window.noveltyReady) return;
    const t = ev.target.closest(`${NOVELTY_CONFIG.SELECTORS.QUANTITY_BUTTONS}, ${NOVELTY_CONFIG.SELECTORS.REMOVE_BUTTONS}, ${NOVELTY_CONFIG.SELECTORS.PRODUCT_LINKS}`);
    if (t) {
      ev.preventDefault();
      ev.stopPropagation();
      showPreparingToast();
    }
  }, true);
}

function lockCartUISelective() {
  const root = getCartRoot();
  if (!root) return;
  injectPreparingStylesOnce();

  window.noveltyReady = false;
  root.setAttribute('aria-busy', 'true');
  root.classList.add('novelty-preparing');

  root.querySelectorAll(NOVELTY_CONFIG.SELECTORS.QUANTITY_BUTTONS).forEach(el => {
    el.setAttribute('disabled', 'true');
    el.setAttribute('aria-disabled', 'true');
  });
  root.querySelectorAll(NOVELTY_CONFIG.SELECTORS.REMOVE_BUTTONS).forEach(el => {
    el.setAttribute('disabled', 'true');
    el.setAttribute('aria-disabled', 'true');
    el.style.pointerEvents = 'none';
  });
  root.querySelectorAll(NOVELTY_CONFIG.SELECTORS.PRODUCT_LINKS).forEach(el => {
    el.setAttribute('tabindex', '-1');
    el.setAttribute('aria-disabled', 'true');
    el.dataset.npLinkDisabled = '1';
  });

  ensurePreparingOverlay(root);
  attachPreparingGuards(root);
}

function unlockCartUISelective() {
  const root = getCartRoot();
  if (!root) return;

  root.removeAttribute('aria-busy');
  root.classList.remove('novelty-preparing');

  root.querySelectorAll(NOVELTY_CONFIG.SELECTORS.QUANTITY_BUTTONS).forEach(el => {
    el.removeAttribute('disabled');
    el.removeAttribute('aria-disabled');
  });
  root.querySelectorAll(NOVELTY_CONFIG.SELECTORS.REMOVE_BUTTONS).forEach(el => {
    el.removeAttribute('disabled');
    el.removeAttribute('aria-disabled');
    el.style.pointerEvents = '';
  });
  root.querySelectorAll(`${NOVELTY_CONFIG.SELECTORS.PRODUCT_LINKS}[data-np-link-disabled="1"]`).forEach(el => {
    el.removeAttribute('tabindex');
    el.removeAttribute('aria-disabled');
    delete el.dataset.npLinkDisabled;
  });

  const ov = root.querySelector('.novelty-preparing-overlay');
  if (ov) ov.remove();

  window.noveltyReady = true;
}

// =========================
//  複数ノベルティ設定の共通取得
// =========================
function getActiveNoveltyConfigs() {
  const configs = [];
  if (window.noveltySettings && window.noveltySettings.enabled) configs.push(window.noveltySettings);
  if (window.noveltySettings2 && window.noveltySettings2.enabled) configs.push(window.noveltySettings2);
  return configs;
}

// =========================
//  ノベルティUI制御
// =========================
function controlNoveltyProductUI() {
  try {
    const noveltyVariantIds = [];
    getActiveNoveltyConfigs().forEach(config => {
      if (config.tier1.variantId) noveltyVariantIds.push(config.tier1.variantId);
      if (config.tier2.variantId) noveltyVariantIds.push(config.tier2.variantId);
    });
    if (noveltyVariantIds.length === 0) return;

    const cartItems = document.querySelectorAll('.cart-item');
    cartItems.forEach(item => {
      let isNoveltyProduct = false;
      let detectedVariantId = null;

      const productLinks = item.querySelectorAll('a[href*="/products/"]');
      productLinks.forEach(link => {
        const href = link.getAttribute('href');
        const variantMatch = href && href.match(/variant=(\d+)/);
        if (variantMatch) {
          const variantId = parseInt(variantMatch[1], 10);
          detectedVariantId = variantId;
          const productTags = cartProductTags[variantId] || [];
          if (productTags.includes('ノベルティ')) {
            isNoveltyProduct = true;
          }
        }
      });

      if (isNoveltyProduct) {
        controlNoveltyItem(item);
      }
    });
  } catch (error) {
    console.error('ノベルティ商品UI制御エラー:', error);
  }
}

function addNoveltyClickLabel(itemElement) {
  const statusLabel = document.createElement('div');
  statusLabel.className = 'novelty-click-label';
  statusLabel.style.cssText = `
    color: red; font-size: 12px; margin-top: 5px;
    padding: 3px 6px; display: inline-block;
  `;
  statusLabel.textContent = 'ノベルティは選択できません';

  const optionElement = itemElement.querySelector('p.product-option');
  if (optionElement) {
    optionElement.parentNode.insertBefore(statusLabel, optionElement.nextSibling);
  } else {
    const productTitle = itemElement.querySelector('.cart-item__name');
    if (productTitle && productTitle.parentNode) {
      productTitle.parentNode.insertBefore(statusLabel, productTitle.nextSibling);
    }
  }
  setTimeout(() => statusLabel.remove(), NOVELTY_CONFIG.DELAYS.LABEL_AUTO_REMOVE);
}

function controlNoveltyItem(itemElement) {
  try {
    const quantityButtons = itemElement.querySelectorAll(NOVELTY_CONFIG.SELECTORS.QUANTITY_BUTTONS);
    quantityButtons.forEach(button => {
      button.disabled = true;
      button.style.opacity = '0.5';
      button.style.cursor = 'not-allowed';
      button.style.pointerEvents = 'none';
      button.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation(); showNoveltyMessage();
      }, true);
    });

    const removeButtons = itemElement.querySelectorAll(NOVELTY_CONFIG.SELECTORS.REMOVE_BUTTONS);
    removeButtons.forEach(button => {
      button.style.pointerEvents = 'none';
      button.style.opacity = '0.5';
      button.style.cursor = 'not-allowed';
      button.setAttribute('disabled', true);
      button.addEventListener('click', function(e) {
        e.preventDefault(); e.stopPropagation(); showNoveltyMessage();
      }, true);
    });

    addNoveltyLabel(itemElement);

    const productNameLinks = itemElement.querySelectorAll(NOVELTY_CONFIG.SELECTORS.PRODUCT_LINKS);
    productNameLinks.forEach(link => {
      if (link.tagName === 'A') {
        link.style.cursor = 'not-allowed';
        link.addEventListener('click', function(e) {
          e.preventDefault(); e.stopPropagation();
          const existingLabel = itemElement.querySelector('.novelty-click-label');
          if (existingLabel) existingLabel.remove();
          addNoveltyClickLabel(itemElement);
        }, true);
      }
    });
  } catch (error) {
    console.error('個別ノベルティ制御エラー:', error);
  }
}

function addNoveltyLabel(itemElement) {
  if (itemElement.querySelector('.novelty-label')) return;
  const label = document.createElement('span');
  label.className = 'novelty-label';
  label.textContent = '🎁 ノベルティ';
  label.style.cssText = `
    display: inline-block; background: #4CAF50; color: white;
    padding: 2px 8px; border-radius: 12px; font-size: 11px;
    font-weight: bold; margin-left: 8px; vertical-align: middle;
  `;
  const productTitle = itemElement.querySelector('.cart-item__name');
  if (productTitle) productTitle.appendChild(label);
}

function showNoveltyMessage() {
  const existing = document.querySelector('.novelty-message');
  if (existing) existing.remove();
  const message = document.createElement('div');
  message.className = 'novelty-message';
  message.textContent = 'ノベルティ商品は変更・削除できません';
  message.style.cssText = `
    position: fixed; top: 50%; left: 50%; transform: translate(-50%,-50%);
    background: #ff9800; color: #fff; padding: 12px 24px;
    border-radius: 8px; font-weight: bold; z-index: 10000;
    box-shadow: 0 4px 12px rgba(0,0,0,0.3);
  `;
  document.body.appendChild(message);
  setTimeout(() => message.remove(), NOVELTY_CONFIG.DELAYS.LABEL_AUTO_REMOVE);
}

// =========================
//  UI更新
// =========================
async function updateCartUI() {
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const cartCountSelectors = [
      '[data-cart-count]', '.cart-count', '.cart__count',
      '.cart-item-count', '#cart-icon-bubble',
      '.header__icon--cart .visually-hidden'
    ];
    cartCountSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => { el.textContent = cart.item_count; });
    });

    const cartTotalSelectors = [
      '[data-cart-total]', '.cart-total', '.cart__total', '.totals__subtotal-value'
    ];
    cartTotalSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        el.textContent = Shopify.formatMoney ?
          Shopify.formatMoney(cart.total_price) :
          `¥${(cart.total_price / 100).toLocaleString()}`;
      });
    });

    if (window.location.pathname === '/cart' ||
        document.querySelector('.cart-drawer.active') ||
        document.querySelector('.drawer.drawer--cart.is-open')) {
      window.location.reload();
      return;
    }

    const ajaxCartSelectors = ['.cart-drawer', '.mini-cart', '.cart-popup', '[data-cart-section]'];
    let ajaxCartFound = false;
    for (const selector of ajaxCartSelectors) {
      const cartElement = document.querySelector(selector);
      if (cartElement) {
        await updateCartSection(cartElement);
        ajaxCartFound = true;
        break;
      }
    }

    if (!ajaxCartFound) {
      setTimeout(() => window.location.reload(), NOVELTY_CONFIG.DELAYS.CART_MONITOR);
      return;
    }

    setTimeout(() => { controlNoveltyProductUI(); }, NOVELTY_CONFIG.DELAYS.CART_MONITOR);
  } catch (error) {
    console.error('カートUI更新エラー:', error);
    setTimeout(() => window.location.reload(), NOVELTY_CONFIG.DELAYS.CART_MONITOR);
  }
}

async function updateCartSection(cartElement) {
  try {
    let sectionId = cartElement.getAttribute('data-section-id') ||
                    cartElement.closest('[data-section-id]')?.getAttribute('data-section-id') ||
                    'cart-drawer';
    const response = await fetch(`/?section_id=${sectionId}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
    if (!response.ok) throw new Error(`セクション更新失敗: ${response.status}`);
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newCartElement = doc.querySelector(`[data-section-id="${sectionId}"]`) ||
                           doc.querySelector('.cart-drawer') ||
                           doc.body.firstElementChild;
    if (!newCartElement) throw new Error('新しいカート要素が見つかりません');
    cartElement.innerHTML = newCartElement.innerHTML;
  } catch (error) {
    console.error('カートセクション更新エラー:', error);
    window.location.reload();
  }
}

// =========================
//  タグ情報取得
// =========================
// 商品ハンドル単位でタグをキャッシュし、既知の商品は再フェッチしない（API通信最適化）
let productTagsCache = {};

async function updateCartProductTags(cart) {
  try {
    cartProductTags = {};
    const uniqueHandles = [...new Set(cart.items.map(item => item.handle).filter(Boolean))];
    const handlesToFetch = uniqueHandles.filter(handle => !(handle in productTagsCache));

    await Promise.all(handlesToFetch.map(async (handle) => {
      try {
        const productResponse = await fetch(`/products/${handle}.js`);
        if (productResponse.ok) {
          const product = await productResponse.json();
          productTagsCache[handle] = product.tags || [];
        } else {
          productTagsCache[handle] = [];
        }
      } catch (error) {
        console.error(`商品タグ取得失敗: ${handle}`, error);
        productTagsCache[handle] = [];
      }
    }));

    cart.items.forEach(item => {
      if (item.handle) {
        cartProductTags[item.variant_id] = productTagsCache[item.handle] || [];
      }
    });
  } catch (error) {
    console.error('カート商品タグ更新エラー:', error);
  }
}

// =========================
//  ノベルティ商品情報読込
// =========================
async function loadNoveltyProducts() {
  try {
    const configs = getActiveNoveltyConfigs();
    for (const config of configs) {
      for (const tierKey of ['tier1', 'tier2']) {
        const tier = config[tierKey];
        if (tier.productHandle && !tier.product) {
          const response = await fetch(`/products/${tier.productHandle}.js`);
          if (response.ok) {
            const product = await response.json();
            tier.product = product;
            tier.variantId = product.variants[0].id;
          }
        }
      }
    }
  } catch (error) {
    console.error('商品情報の読み込みに失敗:', error);
  }
}

// =========================
//  条件判定（設定ごとに独立して判定）
// =========================
async function checkNoveltyConditions(cart) {
  try {
    const configs = getActiveNoveltyConfigs();
    return configs.map(config => {
      const hasTargetTag = cart.items.some(item => {
        const productTags = cartProductTags[item.variant_id] || [];
        return productTags.includes(config.triggerTag);
      });

      let targetTier = null;
      if (hasTargetTag) {
        if (config.tier2.productHandle &&
            cart.total_price >= config.tier2.minAmount) {
          targetTier = 'tier2';
        } else if (config.tier1.productHandle &&
                   cart.total_price >= config.tier1.minAmount) {
          targetTier = 'tier1';
        }
      }

      const targetVariantId = targetTier ? config[targetTier].variantId : null;
      return { config, hasTargetTag, targetTier, targetVariantId };
    });
  } catch (error) {
    console.error('条件判定エラー:', error);
    return [];
  }
}

// =========================
//  ノベルティ管理
// =========================
async function manageNoveltyProducts(conditionResults, cart) {
  if (!conditionResults || conditionResults.length === 0) return;
  let cartChanged = false;
  try {
    const noveltyItems = cart.items.filter(item => {
      const productTags = cartProductTags[item.variant_id] || [];
      return productTags.includes('ノベルティ');
    });

    // 現在有効な各設定が対象とするノベルティ候補（維持すべきものと入れ替え対象の判定に使用）
    const candidateVariantIds = [];
    conditionResults.forEach(result => {
      if (result.config.tier1.variantId) candidateVariantIds.push(result.config.tier1.variantId);
      if (result.config.tier2.variantId) candidateVariantIds.push(result.config.tier2.variantId);
    });

    // 各設定が現時点で維持すべきノベルティ（設定ごとに独立して判定した結果）
    const keepVariantIds = [...new Set(conditionResults.map(result => result.targetVariantId).filter(Boolean))];

    const unwantedNovelties = noveltyItems.filter(item =>
      candidateVariantIds.includes(item.variant_id) && !keepVariantIds.includes(item.variant_id)
    );

    for (const item of unwantedNovelties) {
      const success = await removeFromCart(item.variant_id);
      if (success) cartChanged = true;
    }

    for (const targetVariantId of keepVariantIds) {
      const hasTargetNovelty = noveltyItems.some(item => item.variant_id === targetVariantId);
      if (hasTargetNovelty) continue;
      const success = await addToCart(targetVariantId);
      if (success) cartChanged = true;
    }

    if (cartChanged) {
      setTimeout(() => { updateCartUI(); }, NOVELTY_CONFIG.DELAYS.UI_UPDATE);
    } else {
      setTimeout(() => { controlNoveltyProductUI(); }, 200);
    }
  } catch (error) {
    console.error('ノベルティ管理エラー:', error);
  }
}

// =========================
//  カート操作
// =========================
async function addToCart(variantId) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    return response.ok;
  } catch (error) {
    console.error('商品追加エラー:', error);
    return false;
  }
}

async function removeFromCart(variantId) {
  try {
    const response = await fetch('/cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: { [variantId]: 0 } })
    });
    return response.ok;
  } catch (error) {
    console.error('商品削除エラー:', error);
    return false;
  }
}

// =========================
//  ノベルティシステム
// =========================
// 直前に処理したカートの状態（アイテム・数量・合計）を記録し、
// 変化がない場合は再判定・DOM再描画をスキップする
let lastCartSignature = null;
let pendingRunTimeoutId = null;

function computeCartSignature(cart) {
  const itemsSignature = cart.items
    .map(item => `${item.variant_id}:${item.quantity}`)
    .sort()
    .join(',');
  return `${cart.total_price}|${itemsSignature}`;
}

async function runNoveltySystem() {
  if (isProcessing) return;
  isProcessing = true;

  lockCartUISelective();

  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const signature = computeCartSignature(cart);
    if (signature === lastCartSignature) {
      // カート内容に変化がないため、再判定・DOM再描画をスキップ
      controlNoveltyProductUI();
      return;
    }
    lastCartSignature = signature;

    await updateCartProductTags(cart);
    await loadNoveltyProducts();
    const conditionResults = await checkNoveltyConditions(cart);
    if (conditionResults && conditionResults.length > 0) await manageNoveltyProducts(conditionResults, cart);

    controlNoveltyProductUI();
  } catch (error) {
    console.error('ノベルティシステムエラー:', error);
  } finally {
    unlockCartUISelective();
    isProcessing = false;
  }
}

function scheduleRunAfterCartChange(delay = NOVELTY_CONFIG.DELAYS.CART_MONITOR) {
  lockCartUISelective();
  // 短時間に複数回トリガーされても最後の1回だけ実行し、重複APIリクエストを防ぐ
  if (pendingRunTimeoutId) clearTimeout(pendingRunTimeoutId);
  pendingRunTimeoutId = setTimeout(() => {
    pendingRunTimeoutId = null;
    runNoveltySystem();
  }, delay);
}

// =========================
//  カート監視
// =========================
function startCartMonitoring() {
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const url = args[0];
    if (typeof url === 'string' && (
      url.includes('/cart/add.js') ||
      url.includes('/cart/update.js') ||
      url.includes('/cart/change.js') ||
      url.includes('/cart/clear.js')
    )) {
      return originalFetch.apply(this, args).then(response => {
        if (response.ok && !isProcessing) scheduleRunAfterCartChange();
        return response;
      });
    }
    return originalFetch.apply(this, args);
  };

  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form.action && (form.action.includes('/cart/add') || form.action.includes('/cart/update'))) {
      scheduleRunAfterCartChange(1000);
    }
  });

  document.addEventListener('click', function(event) {
    const button = event.target;
    if (button.type === 'submit' ||
        button.classList.contains('btn') ||
        button.textContent.includes('カート') ||
        button.textContent.includes('追加') ||
        button.closest('form[action*="cart"]')) {
      scheduleRunAfterCartChange(NOVELTY_CONFIG.DELAYS.BUTTON_CLICK);
    }
  });
}

// =========================
//  初期化
// =========================
document.addEventListener('DOMContentLoaded', () => {
  injectPreparingStylesOnce();
  startCartMonitoring();

  setTimeout(() => {
    runNoveltySystem().then(() => {
      setTimeout(() => { controlNoveltyProductUI(); }, 1000);
    });
  }, NOVELTY_CONFIG.DELAYS.SYSTEM_INIT);
});